import styled from 'styled-components';
import { Card } from 'antd';

export const Wrapper = styled(Card)`

  /* margin-top: 2%;
  margin-right: 8%;
  margin-left: 8%;
  margin-bottom: 20%; */
  .ant-drawer-right.ant-drawer-open .ant-drawer-content-wrapper {
  box-shadow: none;
  background: red !important;
}
.ant-table .ant-table-small .ant-table-ping-right .ant-table-scroll-horizontal{
  box-shadow: none;
  background: red !important;
}

  .cardFiltroEstagiarios{
  /* background-color: blue !important; */
  /* padding: 20px; */
  /* margin: 10px; */
  /* background: red; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
    /* /* align-content: center ; */
  align-items: center; 

}
  .filtroEstagiarios{
    width: 100%;
    /* background-color: yellow !important; */
    /* margin:20px ; */
    box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.20);
    border: 1px solid #cecece;
    border-radius: 5px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-content: center ;
    align-items: center;
    /* flex-direction: row; */
  }
  .ant-row{
    align-items: center;
  }

  .filtroEstagiarios {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    /* background: blue; */
    /* width: 100%; */
    /* margin-top: 10px; */
    /* width: 100%; */
    /* background: red !important; */
  }
  .container-dropdown {
    /* background: yellow; */
    width: 30%;
  }


  .filtroEstatistica .ant-statistic{
    justify-content: space-around;
    align-items: center;
    /* background: yellow; */
    width: 200px;
    height: 80px;
    /* margin-bottom: 10px; */
    /* width: 100%; */
    /* background: yellow; */
    align-items: center;
    text-align: center;
    padding: 10px;
  }
  .cardsEstatistic{
    width: 100%;
    /* background: red; */
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  .input-cpf{
    width: 40%;
  }
  .filtroEstatistica{
    /* background: green; */
    /* width: 100%; */
    border: 1px solid #cecece;
    border-radius: 5px;
    box-shadow: 10px 7px 11px -5px rgba(0,0,0,0.20);
    justify-content: space-around;
    padding: 20px;
    align-items: center;
    text-align: center;
    /* margin-left: 0px; */
    /* background-color: red !important; */
    display: flex;
    /* align-content: center 
    text-aligcentern; */
    /* align-items: center; */
    /* flex-direction: row; */
  }
  .filtroEstagiarios .ant-select{
      /* margin-top:10px ; */
      /* background: green; */
      width: 60%;
      padding-right: 10px;
    }
  
  .areaExport{
    display: flex;
    justify-content: right;

  }
  @media (max-width: 1450px) {
    .cardFiltroEstagiarios{
      margin-top: 10px;
      flex-direction: column;
    }
    .filtroEstagiarios{
      margin-top: 30px;
    width: 70%;
    /* background: yellow; */
     }
    .filtroEstatistica{
      flex-direction: column;

      /* width: 70%; */
      /* background: blue; */
    }
    .filtroEstatistica{
      margin-bottom: 10px;
    }
    .cardsEstatistic{

      flex-direction: column;
    }
    .filtroEstagiarios {
      width: 100%;
      /* width: 1050px; */
      flex-direction: column;
      padding: 20px;
      margin:0px
    }
    .filtroEstagiarios .ant-select{
      margin-top:10px ;
      /* background: green; */
      width: 100%;
    }
    .input-cpf{
    width: 100%;
  }
    /* background: red; */
  }

`;